import { AnimatePresence } from 'framer-motion';
import { useUIStore } from './store/uiStore';
import HackerToggleSwitch from './components/ui/HackerToggleSwitch';
import LanguageSelector from './components/ui/LanguageSelector';
import { useGeoLanguage } from './lib/useGeoLanguage';

import HomeBoard from './components/boards/HomeBoard';
import OrderBoard from './components/boards/OrderBoard';
import Footer from './components/home/Footer';
import MatrixBackground from './components/effects/MatrixBackground';
import HackerCursor from './components/effects/HackerCursor';
import AdminInterface from './components/admin/AdminInterface';
import PaymentReturn from './components/order/PaymentReturn';
import PaymentContinue from './components/order/PaymentContinue';
import CompletePayment from './components/order/CompletePayment';
import './App.css';

function App() {
    const { currentBoard, switchStatus, requestModeChange } = useUIStore();
    // Initialize geo-based language detection
    useGeoLanguage();
    
    const isAdminRoute = window.location.pathname === '/admin';
    const pathname = window.location.pathname;
    const isPaymentContinueRoute = pathname === '/payment/continue';
    const isPaymentReturnRoute =
        pathname === '/payment/return' || /^\/order\/[^/]+\/return\/?$/.test(pathname);
    const isCompletePaymentRoute = pathname === '/payment/complete';

    const isMainBoard = !isAdminRoute && !isPaymentContinueRoute && !isPaymentReturnRoute && !isCompletePaymentRoute;

    const handleModeChange = async (mode: 'home' | 'order') => {
        // Convert to uppercase for store
        const boardMode = mode.toUpperCase() as 'HOME' | 'ORDER';
        await requestModeChange(boardMode);
    };

    return (
        <div className="App">
            {/* Language selector - global */}
            <div className="language-selector-container">
                <LanguageSelector />
            </div>
            
            <HackerCursor />
            <MatrixBackground />

            <HackerToggleSwitch
                mode={currentBoard === 'HOME' ? 'home' : 'order'}
                status={switchStatus}
                onModeChange={handleModeChange}
                visible={isMainBoard}
                holdDuration={1000}
            />

            {isAdminRoute ? (
                <AdminInterface />
            ) : isPaymentContinueRoute ? (
                <PaymentContinue />
            ) : isPaymentReturnRoute ? (
                <PaymentReturn />
            ) : isCompletePaymentRoute ? (
                <CompletePayment />
            ) : (
                <>
                    <AnimatePresence mode="wait">
                        {currentBoard === 'HOME' && (
                            <HomeBoard
                                key="home"
                                onNavigateToOrder={() => requestModeChange('ORDER')}
                            />
                        )}
                        {currentBoard === 'ORDER' && <OrderBoard key="order" />}
                    </AnimatePresence>
                    <Footer />
                </>
            )}
        </div>
    );
}

export default App;
